import { HttpClient } from '@angular/common/http';
import {
  Component, computed, inject, OnInit, signal,
} from '@angular/core';
import { OfflineNotification, OfflineService } from '../../services/offline.service';
import { Environment, NimmstaCommonsModuleConfiguration } from '../../nimmsta-commons-module.config';
import { TranslatePipe } from '@ngx-translate/core';

const RETRY_INTERVAL_MS = 4000;

@Component({
    selector: 'app-offline-toast',
    templateUrl: './offline-toast.component.html',
    imports: [TranslatePipe],
})
export class OfflineToastComponent implements OnInit {
  offlineStates = signal<OfflineNotification>({});

  showToast = computed(() => Object.values(this.offlineStates()).some((offline) => offline));

  intervals: number[] = [];

  private offlineService = inject(OfflineService);
  private http = inject(HttpClient);
  private configuration = inject(NimmstaCommonsModuleConfiguration);

  ngOnInit(): void {
    this.offlineService.offlineObservable.subscribe((notification) => {
      const changed = Object.keys(notification) !== Object.keys(this.offlineStates())
        || Object.keys(notification).some((key) => this.offlineStates()[key] !== notification[key]);
      if (changed) {
        this.offlineStates.set(notification);
        if (this.configuration.environment === Environment.LOCAL) {
          // Don't reload the page in local environment as services won't run on default
          return;
        }
        this.intervals.forEach((interval) => clearInterval(interval));
        Object.entries(this.offlineStates()).forEach(([serviceUrl, offline]) => {
          if (offline) {
            this.intervals.push(setInterval(() => {
              this.tryAgain(serviceUrl);
            }, RETRY_INTERVAL_MS, []));
          }
        });
      }
    });
  }

  private tryAgain(serviceUrl: string) {
    this.http.get(`${serviceUrl}/actuator/health`).subscribe({
      next: () => {
        this.offlineService.setOffline(serviceUrl, false);
        this.offlineStates.set({ ...this.offlineStates(), [serviceUrl]: false });
        this.conditionalReload();
      },
    });
  }

  /**
   * Reload the page if all services are back online
   */
  private conditionalReload() {
    if (!Object.values(this.offlineStates()).some((offline) => offline)) {
      window.location.reload();
    }
  }
}
